export default{
    methods:{
        async generateReport(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/reports/generate_ticket_report', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async generateIndividualReport(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/reports/generate_individual_ticket_report', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async customerListDropdown(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/reports/customer_list_for_dropdown', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async branchListDropdown(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/reports/branch_list_for_dropdown', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async pmReportListView(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/reports/pm_reports_list_view', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async generatePmReport(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/reports/generate_pm_report', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
    }
}